// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditDownloadClientModalContent-deleteButton-Ys0Wc Button-button-2PYOE Link-link-1rgM9","message":"EditDownloadClientModalContent-message-A6WQT Alert-alert-e4rpV"};